/* tv-collection.js: in-place filter / sort / load-more for tv-collection & tv-search (Section Rendering API).
   Progressive enhancement: every control is a real link or GET form, so pages work and crawl without JS. */
(() => {
  const SEL = '[data-tv-cl]';
  const desk = window.matchMedia('(min-width: 990px)');

  function stickyTop() {
    const h = document.querySelector('.shopify-section-header-sticky, .section-header');
    let top = 0;
    if (h) {
      const cs = getComputedStyle(h);
      if (cs.position === 'sticky' || cs.position === 'fixed') top = Math.max(0, Math.round(h.getBoundingClientRect().bottom));
    }
    document.documentElement.style.setProperty('--tv-sticky-top', top + 'px');
  }

  class TvCl {
    constructor(el) {
      this.el = el;
      this.id = el.dataset.sectionId;
      this.ctrl = null;
      this.bind();
    }
    get form() { return this.el.querySelector('[data-tv-form]'); }
    get drawer() { return this.el.querySelector('[data-tv-drawer]'); }
    bind() {
      const el = this.el;
      el.addEventListener('change', (e) => {
        const t = e.target;
        if (t.matches('[data-tv-vsearch]')) return;
        if (t.form && t.form.matches('[data-tv-form]')) this.go(this.formUrl());
      });
      el.addEventListener('input', (e) => { if (e.target.matches('[data-tv-vsearch]')) this.vsearch(e.target); });
      el.addEventListener('keydown', (e) => { if (e.key === 'Enter' && e.target.matches('[data-tv-vsearch]')) e.preventDefault(); });
      el.addEventListener('submit', (e) => {
        if (!e.target.matches('[data-tv-form]')) return;
        e.preventDefault();
        this.close();
        this.go(this.formUrl());
      });
      el.addEventListener('click', (e) => {
        const a = e.target.closest('a[data-tv-link]');
        if (a) { e.preventDefault(); this.go(a.href); return; }
        const m = e.target.closest('a[data-tv-more]');
        if (m) { e.preventDefault(); this.more(m); return; }
        if (e.target.closest('[data-tv-open]')) { this.open(); return; }
        if (e.target.closest('[data-tv-close]')) { this.close(); }
      });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
      window.addEventListener('popstate', () => this.go(location.href, false));
    }
    formUrl() {
      const f = this.form;
      const p = new URLSearchParams();
      for (const [k, v] of new FormData(f)) if (v !== '') p.append(k, v);
      const q = p.toString();
      return f.getAttribute('action') + (q ? '?' + q : '');
    }
    async fetchSection(url) {
      const u = new URL(url, location.origin);
      u.searchParams.set('section_id', this.id);
      const r = await fetch(u.toString(), { signal: this.ctrl.signal, credentials: 'same-origin' });
      if (!r.ok) throw new Error('HTTP ' + r.status);
      const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      return doc.querySelector(SEL);
    }
    async go(url, push = true) {
      if (this.ctrl) this.ctrl.abort();
      this.ctrl = new AbortController();
      const u = new URL(url, location.origin);
      u.searchParams.delete('page');
      u.searchParams.delete('section_id');
      this.el.classList.add('is-loading');
      try {
        const fresh = await this.fetchSection(u.toString());
        if (!fresh) throw new Error('no section');
        this.swap(fresh);
        if (push) history.pushState({ tv: 1 }, '', u.pathname + u.search);
        const res = this.el.querySelector('[data-tv-r="results"]');
        if (res && !this.isOpen() && res.getBoundingClientRect().top < 0) {
          const bar = this.el.querySelector('[data-tv-bar]');
          const off = (bar ? bar.offsetHeight : 0) + parseInt(getComputedStyle(document.documentElement).getPropertyValue('--tv-sticky-top') || 0, 10);
          window.scrollTo({ top: window.scrollY + res.getBoundingClientRect().top - off - 8, behavior: 'smooth' });
        }
      } catch (err) {
        if (err.name !== 'AbortError') location.href = u.toString();
      } finally {
        this.el.classList.remove('is-loading');
      }
    }
    swap(fresh) {
      this.el.querySelectorAll('[data-tv-r]').forEach((old) => {
        const n = fresh.querySelector('[data-tv-r="' + CSS.escape(old.dataset.tvR) + '"]');
        if (n) old.replaceWith(n);
      });
      const ns = fresh.querySelector('[data-tv-sort]');
      const os = this.el.querySelector('[data-tv-sort]');
      if (ns && os) os.value = ns.value;
      this.el.querySelectorAll('[data-tv-vsearch]').forEach((i) => { if (i.value) this.vsearch(i); });
    }
    async more(a) {
      if (this.ctrl) this.ctrl.abort();
      this.ctrl = new AbortController();
      a.classList.add('is-busy');
      a.textContent = 'Loading…';
      try {
        const fresh = await this.fetchSection(a.href);
        const grid = this.el.querySelector('[data-tv-grid]');
        const items = fresh ? fresh.querySelectorAll('[data-tv-grid] > li') : [];
        const first = items[0];
        items.forEach((li) => grid.appendChild(li));
        const wrap = this.el.querySelector('[data-tv-more-wrap]');
        const nwrap = fresh && fresh.querySelector('[data-tv-more-wrap]');
        if (wrap && nwrap) wrap.replaceWith(nwrap);
        const link = first && first.querySelector('a');
        if (link) link.focus({ preventScroll: true });
      } catch (err) {
        if (err.name !== 'AbortError') location.href = a.href;
      }
    }
    vsearch(i) {
      const q = i.value.trim().toLowerCase();
      const box = i.closest('.tv-f');
      box.querySelectorAll('.tv-f__list li').forEach((li) => { li.hidden = !!q && !li.textContent.toLowerCase().includes(q); });
      box.querySelectorAll('.tv-f__grp').forEach((g) => {
        const ul = g.nextElementSibling;
        g.hidden = !!ul && ![...ul.children].some((li) => !li.hidden);
      });
    }
    isOpen() { return this.drawer && this.drawer.classList.contains('is-open'); }
    open() {
      if (desk.matches || !this.drawer) return;
      this.drawer.classList.add('is-open');
      document.documentElement.classList.add('tv-noscroll');
      const b = this.el.querySelector('[data-tv-open]');
      if (b) b.setAttribute('aria-expanded', 'true');
      const x = this.drawer.querySelector('.tv-cl__x');
      if (x) x.focus({ preventScroll: true });
    }
    close() {
      if (!this.isOpen()) return;
      this.drawer.classList.remove('is-open');
      document.documentElement.classList.remove('tv-noscroll');
      const b = this.el.querySelector('[data-tv-open]');
      if (b) { b.setAttribute('aria-expanded', 'false'); b.focus({ preventScroll: true }); }
    }
  }

  function init() {
    stickyTop();
    window.addEventListener('resize', stickyTop, { passive: true });
    window.addEventListener('scroll', () => { if (!init.t) init.t = requestAnimationFrame(() => { init.t = 0; stickyTop(); }); }, { passive: true });
    document.querySelectorAll(SEL).forEach((el) => { if (!el.tvCl) el.tvCl = new TvCl(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
